module.exports = "<ul class=\"program-types\">\n  <li\n    ng-repeat=\"education in ::vm.allEducation track by education.id\"\n    ng-class=\"{ required : vm.checkEducationRequirement($index), 'un-required' : !vm.checkEducationRequirement($index) }\"\n    title=\"{{::education.name}}\">\n    <div ng-transclude></div>\n    <div class=\"user-education-marker\" ng-if=\"vm.userEducation.id === education.id\"></div>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidePanelEducation/sidePanelEducation.html
// module id = 96
// module chunks = 0 1